module.exports = __webpack_public_path__ + "img/27_34.05124841.png";